import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { LoadingFullScreen } from '../../components/Loading/Loading';
import AuthService from '../../services/AuthService';
import { getParameterByName } from '../../helpers/window-helper';
import { getUser } from '../../services/HatApiService';
import { RouterPaths } from '../../constants/routes';

const AuthenticateHatPage: React.FC<OwnProps> = () => {
  const history = useHistory();

  async function getUserProfile() {
    try {
      const hatUrl = AuthService.getHatname();

      if (hatUrl) {
        const res = await getUser();

        if (res.parsedBody) {
          history.replace(RouterPaths.dashboard);
        }
      }
    } catch (error) {
      AuthService.logout();

      const token = getParameterByName('token');
      const userJson = sessionStorage.getItem('signup');

      if (!token || !userJson) {
        history.replace(RouterPaths.signup);
      }

      if (token && !userJson) {
        history.replace(`${RouterPaths.signup}?token=${token}`);
      }

      if (token && userJson) {
        history.replace(`${RouterPaths.authenticateSignup}?token=${token}`);
      }
    }
  }

  useEffect(() => {
    const token = getParameterByName('token');

    if (token) {
      AuthService.login(token);
    }

    if (AuthService.loggedIn()) {
      getUserProfile();
    } else {
      history.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>
      <LoadingFullScreen />
    </div>
  );
};

interface OwnProps {
  path?: string;
  exact?: boolean;
}

export default AuthenticateHatPage;
